<!-- Adapted from Swing src/components/shared/CardScroller.vue, fixed
     f0b87657c6450dc12d2dfd286b75f501410dcabd, MIT / Mungai Njoroge.
     rinfo / rtitle / rdesc / recentitems and dynamic card dispatch retained.
     Vue 2 Options API and a local ResizeObserver replace Swing Pinia width state;
     an empty collection is an empty state, not an indefinite placeholder shelf. -->
<template>
  <section class="cardscroller" :aria-label="title">
    <div class="rinfo">
      <div class="rtitle"><h2><router-link v-if="route" :to="route">{{ title }}</router-link><span v-else>{{ title }}</span></h2><SeeAll v-if="!description && route && items.length" :route="route" :text="seeAllText" /></div>
      <div v-if="description" class="rdesc"><span>{{ description }}</span><SeeAll v-if="route && items.length" :route="route" :text="seeAllText" /></div>
    </div>
    <div v-if="loading || items.length" class="recentitems" :style="{ '--shelf-columns': maxAlbumCards }" :aria-busy="loading ? 'true' : null">
      <component :is="getComponent(item.type)" v-for="item in itemlist" :key="item.key" class="hlistitem" v-bind="getProps(item)" @play="$emit('play', $event)" />
    </div>
    <div v-else class="shelf-empty"><slot name="empty">{{ emptyText }}</slot></div>
  </section>
</template>
<script>
import TrackCard from './TrackCard.vue';
import PlaylistCard from './PlaylistCard.vue';
import CardContent from './CardContent.vue';
import SeeAll from './SeeAll.vue';
export default {
  name: 'SwingCardScroller', components: { TrackCard, PlaylistCard, CardContent, SeeAll },
  props: { title: { type: String, required: true }, description: { type: String, default: '' }, items: { type: Array, default: () => [] }, route: { type: String, default: '' }, seeAllText: { type: String, default: '' }, emptyText: { type: String, default: '暂无内容' }, loading: Boolean },
  data() { return { maxAlbumCards: 4 }; },
  computed: { itemlist() { return this.loading ? Array.from({ length: this.maxAlbumCards }, (_, index) => ({ type: 'placeholder', key: 'loading-' + index })) : this.items.slice(0, this.maxAlbumCards); } },
  mounted() {
    const resize = () => {
      const style = getComputedStyle(this.$el);
      const minimum = parseFloat(style.getPropertyValue('--shelf-card-min'));
      const gap = parseFloat(style.getPropertyValue('--shelf-gap'));
      this.maxAlbumCards = Math.max(1, Math.floor((this.$el.clientWidth + gap) / (minimum + gap)));
    };
    resize();
    if (typeof ResizeObserver !== 'undefined') { this._shelfObserver = new ResizeObserver(resize); this._shelfObserver.observe(this.$el); }
  },
  beforeDestroy() { if (this._shelfObserver) this._shelfObserver.disconnect(); },
  methods: {
    getComponent(type) { return type === 'track' ? 'TrackCard' : type === 'playlist' ? 'PlaylistCard' : 'CardContent'; },
    getProps(item) { return item.type === 'track' ? { track: item.item } : item.type === 'playlist' ? { playlist: item.item } : { withHelptext: true }; },
  },
};
</script>
<style scoped>
.cardscroller { --shelf-card-min:152px; --shelf-gap:12px; padding:12px 0; min-width:0; }
.recentitems { gap:var(--shelf-gap); display:grid; grid-template-columns:repeat(var(--shelf-columns),minmax(0,1fr)); align-items:start; }
.rinfo { padding:0 8px; margin-bottom:8px; }
.rtitle { font-size:14px; display:flex; align-items:baseline; justify-content:space-between; gap:12px; }
.rtitle h2 { font-size:inherit; font-weight:500; margin:0; min-width:0; line-height:1.5; }
.rdesc { font-size:12px; color:var(--salt-subtext,var(--color-secondary)); display:flex; align-items:baseline; justify-content:space-between; gap:12px; margin-top:3px; }
.shelf-empty { margin:0 8px; padding:12px 0; font-size:14px; line-height:1.5; color:var(--salt-subtext,var(--color-secondary)); }
</style>
